import {
  Action,
  ActionType,
  FullStressTypePDFDownloadResponse,
} from "models/stressCheck/fullStressTypeDownloadPdf";
import createReducer from "redux/createReducer";

export interface FullStressPDFDownloadReducerType {
  loading: boolean;
  error?: string;
  fullStressPdfDownloadResponse?: FullStressTypePDFDownloadResponse;
}

const defaultState: FullStressPDFDownloadReducerType = {
  loading: false,
  error: undefined,
  fullStressPdfDownloadResponse: undefined,
};

export const fullStressPdfDownloadReducer =
  createReducer<FullStressPDFDownloadReducerType>(defaultState, {
    [ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF](
      state: FullStressPDFDownloadReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF_ERROR](
      state: FullStressPDFDownloadReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF_SUCCESS](
      state: FullStressPDFDownloadReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressPdfDownloadResponse: action.payload,
      };
    },

    [ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF_RESET_DATA](
      state: FullStressPDFDownloadReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressPdfDownloadResponse: [],
      };
    },
  });
